import router from 'next/router';
import { getRoute } from './routes';

export const redirectToHomePage = (path, domain) => {
  router.push(getRoute(path, domain));
};
